import { SET_EVE_CLIENT_VERSION, SET_LAUNCHER_BACKEND_VERSION } from './constants'

export function setEveClientVersion(serverId, version) {
    return {
        type: SET_EVE_CLIENT_VERSION,
        payload: { serverId, version },
    }
}

export function setLauncherBackendVersion(version) {
    return {
        type: SET_LAUNCHER_BACKEND_VERSION,
        payload: version,
    }
}



// WEBPACK FOOTER //
// ./src/features/Backend/data/versions/actions.js